import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';

const PermissionsContext = createContext({ permissions: [], isAdmin: false, isStaff: false, loading: true, has: () => false });

export const PermissionsProvider = ({ children }) => {
  const { api, user } = useAuth();
  const [state, setState] = useState({ permissions: [], isAdmin: false, isStaff: false, loading: true });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!user) { setState({ permissions: [], isAdmin: false, isStaff: false, loading: false }); return; }
      try {
        const res = await api.get('/intern/permissions');
        if (cancelled) return;
        setState({
          permissions: res.data?.permissions || [],
          isAdmin: !!res.data?.is_admin,
          isStaff: !!res.data?.is_staff,
          loading: false,
        });
      } catch {
        if (!cancelled) setState({ permissions: [], isAdmin: false, isStaff: false, loading: false });
      }
    })();
    return () => { cancelled = true; };
  }, [api, user]);

  const has = (perm) => state.isAdmin || (state.permissions || []).includes(perm);

  return (
    <PermissionsContext.Provider value={{ ...state, has }}>
      {children}
    </PermissionsContext.Provider>
  );
};

export const usePermissions = () => useContext(PermissionsContext);

/** Renders children only if the current user has `perm`. Platform admins always pass. */
export const PermissionGate = ({ perm, fallback = null, children }) => {
  const { has, loading } = usePermissions();
  if (loading) return null;
  if (!has(perm)) return fallback;
  return <>{children}</>;
};

export default PermissionsContext;
